export const AUTH_START =  "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";

export const ADD_ANIME_START = "ADD_ANIME_START"
export const ADD_ANIME_SUCCESS = "ADD_ANIME_SUCCESS"
export const ADD_ANIME_FAIL = "ADD_ANIME_FAIL"



// WEBPACK FOOTER //
// ./src/store/action/actionTypes.js